import React from "react";
import "./ActionButton.css";
import { primaryColor } from "../../utilities/colors";
function ActionButton({
  hoverColor = primaryColor.primary,
  icon,
  name,
  isVTEX,
  onClick,
  className,
  ...restProps
}) {
  return (
    <button
      {...restProps}
      className={`${isVTEX ? "ActionButtonVTEX" : "ActionButton"} ${className}`}
      type="button"
      onClick={onClick}
    >
      {name}
    </button>
  );
}

export default ActionButton;
